export class CategoriaItemModel {
  constructor({ id, descricao, descricaoCompleta, flagPeca = false }) {
    this.id = id;
    this.descricao = descricao;
    this.descricaoCompleta = descricaoCompleta;
    this.flagPeca = flagPeca;
  }
}
